const _ = require('underscore');
const React = require('react');
const Row = require('./Row.jsx');
const createReactClass = require("create-react-class");

const Dashboard = createReactClass({
  dashboardClasses: function() {
    let wrapperClassList = "metric-dashboard";
    if (!this.props.selected) {
      wrapperClassList += " hidden";
    }

    return wrapperClassList;
  },

  render: function() {
    const model = this.props.model;
    const selectedTimeRange = this.props.timeRange;
    const self = this;

    const rows = _.map(this.props.item.rows, function(item) {
      return (
        <Row
          key={item.id}
          model={model}
          item={item}
          timeRange={selectedTimeRange}
          showDeployments={self.props.showDeployments}
          showVirtualStacks={self.props.showVirtualStacks}
        />
      );
    });

    return (
      <div className={this.dashboardClasses()}>
        {rows}
      </div>
    );
  }
});

module.exports = Dashboard;
